/**
 * @generated SignedSource<<663cf11aa6d52c06d5e93b99c808e2cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedAboutItemPanel_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_item" | "PdpRespSimilarSoldItemsLoading_item" | "PdpRespSimilarSoldItems_item" | "PdpSharedDescriptionAbout_item" | "useShouldShowSimilarSoldItems_item">;
  readonly " $fragmentType": "PdpRespSharedAboutItemPanel_item";
};
export type PdpRespSharedAboutItemPanel_item$key = {
  readonly " $data"?: PdpRespSharedAboutItemPanel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedAboutItemPanel_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_item"
    },
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItemsLoading_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItems_item"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "77151d06568548369d45df16a53ab355";

export default node;
